import React from 'react'
import { RetentionResource, RoomRetention } from '../../../models/RetentionPolicy'

export const RetentionPolicyRoomResourceBody: React.FC<{ retentionResource: RetentionResource }> = ({ retentionResource }) => {
  const resource = retentionResource as RoomRetention
  return <></>
}
